/** Routes for Grant, Allowance & Stipend Management System */

/** Dashboard */
export const dashboardApi = '/budget-management/dashboard/list'

/** Budget Preparation */
export const budgetPreparationBase = '/budget-management/budget-preparation'
export const budgetPreparationListApi = budgetPreparationBase + '/list'
export const budgetPreparationStoreApi = budgetPreparationBase + '/store'
export const budgetPreparationUpdateApi = budgetPreparationBase + '/update'
export const budgetPreparationToggleStatusApi = budgetPreparationBase + '/toggle-status'

/** Budget Approval */
export const budgetApprovalBase = '/budget-management/budget-approval/'
export const budgetApprovalListApi = budgetApprovalBase + 'list'
export const budgetApprovalNoteApi = budgetApprovalBase + 'note'
export const budgetApprovalUpdateApi = budgetApprovalBase + 'update'

/** Budget Allocation */
export const budgetAllocationBase = '/budget-management/budget-allocation'
export const budgetAllocationListApi = budgetAllocationBase + '/list'
export const budgetAllocationStoreApi = budgetAllocationBase + '/store'
export const budgetAllocationUpdateApi = budgetAllocationBase + '/update'
export const budgetAllocationDetailsApi = budgetAllocationBase + '/details'
export const budgetAllocationToggleStatusApi = budgetAllocationBase + '/toggle-status'
export const searchData = budgetAllocationBase + '/search-data'
// budget Approval nothi
export const budgetApprovalSendNothi = 'nothi/budget-approval/venue-sent-nothi'
